// extracted by mini-css-extract-plugin
export var label = "_c7-1";
export var reminder = "_c7-0";